import { gql } from 'apollo-angular';

export const propertyLicenseTypeQuery = gql`
  query PropertyLicenseType($id: ID!) {
    propertyLicenseType(id: $id) {
      isLTLicense
    }
  }
`;

export const propertyListQuery = gql`
  query PropertyList {
    propertyList {
      id
      name
      imgUrl
      status
      coordinates {
        lat
        lng
      }
    }
  }
`;  

export const propertyConsumptionListQuery = gql`
  query PropertyConsumptionList {
    propertyConsumptionList {
      id
      currency
      todaysConsumption
      thisMonthsConsumption
      actualCosts
      consumption
    }
  }
`;

export const propertyList2Query = gql`
  query PropertyList2 {
    propertyList2 {
      id
      name
      imgUrl
      status
      coordinates {
        lat
        lng
      }
      todaysConsumption
      thisMonthsConsumption
      actualCosts
    }
  }
`;

export const deletePropertyMutation = gql`
  mutation DeleteProperty($id: ID!) {
    deleteProperty(id: $id) {
      id
      name
      imgUrl
      status
      coordinates {
        lat
        lng
      }
     
    }
  }
`;

export const propertyDetailsQuery = gql`
  query PropertyDetails($id: ID!) {
    propertyDetails(id: $id) {
      id
      name
      imgUrl
      status
      coordinates {
        lat
        lng
      }
      fullAddress
      country
      city
      postalCode
      address
      timezone
      currency
      contacts {
        id
        name
        lastName
        email
          role
      }
      gateways {
        id
        name
        serialNumber
      }
      consumptionSources
        heatedFloorArea
        heatingSystemType
        heatingEnergyConsumption
        constructionYear
        category
        electricalEnergyConsumption
    }
  }
`;
export const propertyDetailsConsumptionQuery = gql`
  query PropertyDetailsConsumption($id: ID!) {
    propertyDetailsConsumption(id: $id) {  
      id
      currency
      todaysConsumption
      thisMonthsConsumption
      actualCosts
      consumption
    } 
  }
`;

export const propertyEventsQuery = gql`
  query PropertyEvents($id: ID!) {
    propertyEvents(id: $id) {
      id
      name
      status
      lastUpdate
      condition
    }
  }
`;

export const propertyDeviceQuery = gql`
  query PropertyDevices($id: ID!) {
    propertyDevices(id: $id) {
      id
      name
      status
      category {
        id
        name
      }
      communicationProtocol {
        id
        name
      }
      groups {
        id
        name
      }
    }
  }
`;

export const propertySelectOptionsQuery = gql`
  query PropertySelectOptions {
    propertyList {
      id
      name
    }
  }
`;

export const propertySelectOptionsWImageQuery = gql`
  query PropertySelectOptionsWImage {
    propertyList {
      id
      name
      imgUrl
    }
  }
`;

export const createPropertyMutation = gql`
  mutation CreateProperty($input: PropertyInput!) {
    createProperty(input: $input) {
      id
      name
      coordinates {
        lat
        lng
      }
      fullAddress
      country
      city
      postalCode
      address
      imgUrl
      timezone
      currency
      contacts {
        id
        name
        propertyIds
        lastName
        email
        role
      }
    }
  }
`;

export const updatePropertyMutation = gql`
  mutation UpdateProperty($id: ID!, $input: PropertyInput!) {
    updateProperty(id: $id, input: $input) {
      id
      name
    }
  }
`;

export const propertyDetailContactsQuery = gql`
  query PropertyDetailContacts {
    userList {
      id
      name
      lastName
      email
      role
    }
  }
`;

export const deletePropertyGateway = gql`
  mutation DeletePropertyGateway($propertyId: ID!, $gatewayId: ID!) {
    deletePropertyGateway(propertyId: $propertyId, gatewayId: $gatewayId) {
      id
      name
      serialNumber
    }
  }
`;
export const canDeleteDeviceQuery = gql`
  query CanDeleteDevice($id: ID!) {
    canDeleteDevice(id: $id) {
      dashboards {
        title
        widgets {
          id
          title
        }
      }
      groups {
        id
        name
      }
      alarms {
        id
        name
      }
      contracts {
        id
        name
      }
    }
  }
`;

export const canDeletePropertyQuery = gql`
  query CanDeleteProperty($id: ID!) {
    canDeleteProperty(id: $id) {
      devices {
        id
        name
      }
      dashboards {
        title
        widgets {
          id
          title
        }
      }
    }
  }
`;

